export const EXPERIENCE_DISPLAY_THRESHOLD = 2;
export const SKILLS_DISPLAY_THRESHOLD = 15;
export const CERTIFICATIONS_DISPLAY_THRESHOLD = 3;
export const ASSOCIATIONS_DISPLAY_LIMIT = 3;
